import ImageWrapper from "../ImageComponent/ImageWrapper";

const RandomImageComponent = ({images}) => {
  
  const getRandomImage = () => {
    const randomIndex = Math.floor(Math.random() * images.length);
    return images[randomIndex];
  };

   const { src, alt, width, height,style } = getRandomImage();

  return (
    <div className="w-24 h-24">
    <ImageWrapper
      src={src}
      alt={alt}
      width={width}
      height={height}
      style={style}
    /></div>
  );
};

export default RandomImageComponent;
